var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.2655 13.4969H3.08325V10.3154L11.6595 1.73912C11.8001 1.59852 11.9909 1.51953 12.1898 1.51953C12.3886 1.51953 12.5794 1.59852 12.72 1.73912L14.8418 3.86012C14.9824 4.00077 15.0613 4.1915 15.0613 4.39037C15.0613 4.58924 14.9824 4.77998 14.8418 4.92062L6.2655 13.4969ZM3.08325 14.9969H16.5833V16.4969H3.08325V14.9969Z",
    fill: "#1C64F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d75d391913ff1ae951f4e5dc7c190eeb.svg";
export { ForwardRef as ReactComponent };